import Modal from "react-modal";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { requestHandler } from "../../services/requestHandler";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Loading from "../Loading/Loading";

export default function RefundPayment({ showModal, setShowModal, TxnData }) {
  const [ isLoading, setIsLoading ] = useState(false);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();
  useEffect(() => {
    if (TxnData?.txn_id) setValue("txn_id", TxnData?.txn_id);
    console.log("Data :", TxnData);
  }, [showModal]);

  const onSubmit = async (data) => {
    setIsLoading(true);
    const { amount, refundReason } = data;
    const response = await requestHandler(
      "POST",
      "payment/create-refund",
      {
        txn_id: TxnData?.txn_id || "",
        amount: amount ?? 0,
        refundReason,
      },
      dispatch
    );
    if (response?.status) {
      toast.success(response?.message);
      setShowModal(false);
      reset({ amount: "", refundReason: "" });
    }
    setIsLoading(false);
    console.log("response :", response);
  };
  return (
    <>
      {isLoading ? <Loading /> : null}
      <Modal
        isOpen={showModal}
        ariaHideApp={false}
        className="model_block"
        //   onRequestClose={() => setShowModal(false)}
        //   backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Refund Payment</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              >
                <i aria-hidden="true" className="ki ki-close"></i>
              </button>
            </div>
            <div className="modal-body">
              <div className="d-flex">
                <label
                  className="w-100 font-size-h6 text-dark-75 font-weight-bolder"
                  style={{ textAlign: "left" }}
                >
                  Transaction Id:
                </label>
                <p>{TxnData?.txn_id}</p>
              </div>
              <div className="form-group row my-2">
                <div className="col-12">
                  <label
                    className="w-100 font-size-h6 text-dark-75 font-weight-bolder"
                    style={{ textAlign: "left" }}
                  >
                    Amount
                  </label>
                  <input
                    type="text"
                    className={`form-control`}
                    placeholder="Refund Amount"
                    name="amount"
                    {...register("amount", {
                      required: true,
                      pattern: {
                        value: /^(0|[1-9]\d*)(\.\d+)?$/,
                        message: "Amount must be a numeric value.",
                      },
                    })}
                  />
                </div>

                {errors.amount?.type === "required" && (
                  <div
                    className="invalid-feedback ml-4"
                    style={{ textAlign: "left" }}
                  >
                    The field is required.
                  </div>
                )}
                {errors.amount?.type === "pattern" && (
                  <div
                    className="invalid-feedback ml-4"
                    style={{ textAlign: "left" }}
                  >
                    {errors.amount.message}
                  </div>
                )}
                <div className="col-12">
                  <label
                    className="w-100 font-size-h6 text-dark-75 font-weight-bolder"
                    style={{ textAlign: "left" }}
                  >
                    Reason
                  </label>
                  <input
                    type="text"
                    className={`form-control`}
                    placeholder="Refund Reason"
                    name="refundReason"
                    {...register("refundReason", { required: true })}
                  />
                </div>
                {errors.refundReason?.type === "required" && (
                  <div
                    className="invalid-feedback ml-4"
                    style={{ textAlign: "left" }}
                  >
                    The field is required.
                  </div>
                )}
                <div className="col-12 mt-2" style={{ textAlign: "left" }}>
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={isLoading}
                    onClick={handleSubmit(onSubmit)}
                  >
                    Submit
                  </button>
                </div>
              </div>
              <div className="clearfix">&nbsp;</div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
